import { paddingXL } from "src/styles/spacing";

export const HEADER_SPACING = {
	paddingTop: paddingXL,
	paddingHorizontal: paddingXL,
	paddingBottom: paddingXL,
};
